<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container"  trigger="click">
        <div class="avatar-wrapper">
          <img src="../../assets/images/avator.jpg" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
          <div class="name">
            <p :class="{two:userInfo.workNo}" v-if="userInfo.name">
              <b>{{userInfo.name}}</b>
            </p>
            <p class="two" v-if="userInfo.workNo">{{userInfo.workNo}}</p>
          </div>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
// import FullScreen from '@/components/FullScreen'

export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data () {
    return {
      choseList: [
        {name: '退出'}
      ],
      userInfo: window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : null
    }
  },
  methods: {
    choseOperate () {},
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userInfo');
      this.$router.push({ path: '/login' })
      // window.location.reload()
    }
  }
}
</script>

<style lang="scss" scoped>
.select {
  width: 200px;
  display: flex;
  align-items: center;
  float: right;
  height: 100%;
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  // background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 8px 24px 0px rgba(132, 157, 213, 0.2);
  // background: #fff;
  // box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .app-breadcrumb.el-breadcrumb {
    line-height: 50px;
  }
  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
    .chose-list {
      position: absolute;
      width: 100px;
      top: 45px;
      padding-top: 15px;
      text-align: center;
      transition: max-height 0.3s ease-out;
      // max-height: 151px;
      overflow: hidden;
      background: red;
      li {
        background-color: #1e3c72;
        height: 34px;
        line-height: 34px;
      }
      li:hover {
        background-color: #0c70b8;
      }
    }
    .avatar-container:hover {
      .chose-list {
        max-height: 151px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.name {
  margin-top: 6px;
  margin-right: 10px;
  float: left;

  p.two {
    line-height: 18px;
  }
  p {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Navbar.vue